import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import { IconPadlock } from '../../../../../../assets/control-icons';

type ReedControlProps = {
  value: boolean | null;
};

export const ReedControl: React.FC<ReedControlProps> = ({ value }) => {
  const { t } = useTranslation('channel-details');
  const { t: tc } = useTranslation('common');

  const renderMovementContent = () => {
    if (value === null) {
      return <span className="sensor-control-box__status">{t('exalus.sensor.noData')}</span>;
    }

    return (
      <>
        <IconPadlock isOn={!value} />
        <Typography component="span" marginLeft={1}>
          {!value ? tc('opened') : tc('closed')}
        </Typography>
      </>
    );
  };

  return (
    <Stack direction="row" alignItems="center" justifyContent="center" padding="0 10px">
      {renderMovementContent()}
    </Stack>
  );
};
